import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { CartProvider } from './contexts/CartContext';
import { ToastProvider } from './contexts/ToastContext';
import { Layout } from './components/Layout';
import { Home } from './pages/Home';
import { Events } from './pages/Events';
import { EventView } from './pages/EventView';
import { Clubs } from './pages/Clubs';
import { TravelDeals } from './pages/TravelDeals';
import { Blog } from './pages/Blog';
import { Store } from './pages/Store';
import { Cart } from './pages/Cart';
import { SignIn } from './pages/SignIn';
import { CreateAccount } from './pages/CreateAccount';
import { Contact } from './pages/Contact';
import { Pricing } from './pages/Pricing';
import { BrandAmbassador } from './pages/BrandAmbassador';
import { PacerProgram } from './pages/PacerProgram';
import { PaceTeams } from './pages/PaceTeams';
import { RegistrationFeatures } from './pages/RegistrationFeatures';
import { About } from './pages/About';
export function App() {
  return <Router data-id="element-0">
      <ToastProvider data-id="element-1">
        <CartProvider data-id="element-2">
          <Routes data-id="element-3">
            <Route path="/signin" element={<Layout data-id="element-5">
                  <SignIn data-id="element-6" />
                </Layout>} data-id="element-4" />
            <Route path="/create-account" element={<Layout data-id="element-8">
                  <CreateAccount data-id="element-9" />
                </Layout>} data-id="element-7" />
            <Route path="/" element={<Layout data-id="element-11">
                  <Home data-id="element-12" />
                </Layout>} data-id="element-10" />
            <Route path="/events" element={<Layout data-id="element-14">
                  <Events data-id="element-15" />
                </Layout>} data-id="element-13" />
            <Route path="/events/:id" element={<Layout data-id="element-17">
                  <EventView data-id="element-18" />
                </Layout>} data-id="element-16" />
            <Route path="/clubs" element={<Layout data-id="element-20">
                  <Clubs data-id="element-21" />
                </Layout>} data-id="element-19" />
            <Route path="/travel-deals" element={<Layout data-id="element-23">
                  <TravelDeals data-id="element-24" />
                </Layout>} data-id="element-22" />
            <Route path="/blog" element={<Layout data-id="element-26">
                  <Blog data-id="element-27" />
                </Layout>} data-id="element-25" />
            <Route path="/store" element={<Layout data-id="element-29">
                  <Store data-id="element-30" />
                </Layout>} data-id="element-28" />
            <Route path="/cart" element={<Layout data-id="element-32">
                  <Cart data-id="element-33" />
                </Layout>} data-id="element-31" />
            <Route path="/create-account" element={<Layout data-id="element-35">
                  <CreateAccount data-id="element-36" />
                </Layout>} data-id="element-34" />
            <Route path="/sign-in" element={<Layout data-id="element-38">
                  <SignIn data-id="element-39" />
                </Layout>} data-id="element-37" />
            <Route path="/contact" element={<Layout data-id="element-41">
                  <Contact data-id="element-42" />
                </Layout>} data-id="element-40" />
            <Route path="/pricing" element={<Layout data-id="element-44">
                  <Pricing data-id="element-45" />
                </Layout>} data-id="element-43" />
            <Route path="/brand-ambassador" element={<Layout data-id="element-47">
                  <BrandAmbassador data-id="element-48" />
                </Layout>} data-id="element-46" />
            <Route path="/pacer-program" element={<Layout data-id="element-50">
                  <PacerProgram data-id="element-51" />
                </Layout>} data-id="element-49" />
            <Route path="/pace-teams" element={<Layout data-id="element-53">
                  <PaceTeams data-id="element-54" />
                </Layout>} data-id="element-52" />
            <Route path="/registration-features" element={<Layout data-id="element-56">
                  <RegistrationFeatures data-id="element-57" />
                </Layout>} data-id="element-55" />
            <Route path="/about" element={<Layout data-id="element-59">
                  <About data-id="element-60" />
                </Layout>} data-id="element-58" />
          </Routes>
        </CartProvider>
      </ToastProvider>
    </Router>;
}